import { BREAKPOINT_MD, BREAKPOINT_LG, BREAKPOINT_XL } from "./constants";

/**
 * getElementNaturalHeight
 * Copy element into a hidden area where
 * we can let it flow to its natural height
 */
export const getElementNaturalHeight = (element, options = {}) => {
  // create a secret dom element
  const { wrapperClass, parentNode } = options;

  var wrapper = document.createElement("div");
  wrapper.style.cssText = "position: fixed; left: -9999px; visibility: hidden;";

  wrapper.id = "shadow-node";

  if (wrapperClass) {
    wrapper.classList.add(wrapperClass);
  }

  let shadowCopy = element.cloneNode(true);
  shadowCopy.style.cssText = "height: auto; display: block; position: static;";

  wrapper.append(shadowCopy);

  let parent = parentNode ? parentNode : element.parentNode;

  parent.appendChild(wrapper);

  let dimensions = wrapper.getBoundingClientRect();

  // cleanup
  parent.removeChild(wrapper);

  return dimensions.height;
};

/**
 * getCoords
 * @param {*} elem
 * Function I pulled from Stack overflow that attempts give an accurate coordidinate of an element
 * relative to the document. Native functions are relative to the window and thus affected by scroll position.
 */
export const getDocumentCoords = (elem) => {
  // crossbrowser version
  var box = elem.getBoundingClientRect();

  var body = document.body;
  var docEl = document.documentElement;

  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;

  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;

  return {
    top: Math.round(top),
    left: Math.round(left),
  };
};

/**
 * isTouchDevice
 */
export const isTouchDevice = () => {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");

  var mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};

/**
 * getBreakpointIndex
 */
export const getBreakpointIndex = () => {
  let breakpoint = 0;

  if (window.innerWidth > BREAKPOINT_XL) {
    breakpoint = 3;
  } else if (window.innerWidth > BREAKPOINT_LG) {
    breakpoint = 2;
  } else if (window.innerWidth > BREAKPOINT_MD) {
    breakpoint = 1;
  }
  return breakpoint;
};
